import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CampaignerV3Component } from './campaigner-v3.component';
import { DonateNowModule } from '../donate-now/donate-now.module';
import { WhatsappShareModule } from '../whatsapp-share/whatsapp-share.module';
import { SharedModule } from '../../shared/shared.module';
import { ContactBeneficiaryModule } from '../contact-beneficiary/contact-beneficiary.module';
import { MatButtonModule } from '@angular/material/button';
import { ViewSupportersModule } from '../view-supporters/view-supporters.module';
import { MatTooltipModule } from '@angular/material/tooltip';



@NgModule({
  declarations: [CampaignerV3Component],
  exports: [CampaignerV3Component],
  imports: [
    CommonModule,
    DonateNowModule,
    WhatsappShareModule,
    SharedModule,
    ContactBeneficiaryModule,
    MatButtonModule,
    ViewSupportersModule,
    MatTooltipModule
  ]
})
export class CampaignerV3Module { }
